var _defs, _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 107 90",
    width: 107,
    height: 90,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-738-1368h1366v3181h-1366z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#ff9500}.b{fill:#fbab01}.c{fill:#fac100}.d{fill:#00cf66}.e{fill:#00b157}.f{fill:#eaeff0}.g{fill:#e8615b}.h{fill:#fff}")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp1)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m82.8 18.9l-39.8-17.7c-0.6-0.3-1.3-0.3-1.8 0l-39.9 17.7c-0.8 0.4-1.3 1.2-1.3 2v48.7c0 0.9 0.5 1.7 1.3 2.1l39.9 17.7c0.5 0.2 1.2 0.2 1.8 0l39.8-17.7c0.8-0.4 1.3-1.2 1.3-2.1v-48.7c0-0.8-0.5-1.6-1.3-2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m43 89.4l39.8-17.7c0.8-0.4 1.3-1.2 1.3-2.1v-48.7c0-0.8-0.5-1.6-1.3-2l-39.8-17.7q-0.5-0.2-0.9-0.2v88.6q0.4 0 0.9-0.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m42.1 38.6l41.8-18.6c-0.2-0.5-0.6-0.9-1.1-1.1l-39.8-17.7c-0.6-0.3-1.3-0.3-1.8 0l-39.9 17.7c-0.5 0.2-0.9 0.6-1.1 1.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m23.6 30.4l42.6-18.9-5.4-2.4-42.6 18.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "d",
    d: "m68.6 89.6c-11 0-19.9-8.9-19.9-20 0-11 8.9-19.9 19.9-19.9 11.1 0 20 8.9 20 19.9 0 11.1-8.9 20-20 20z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m72 85.1c-8 0.1-15.2-5-17.8-12.6-2.6-7.6-0.2-16 6.1-20.9-8 3.6-12.6 12.2-11.4 20.9 1.3 8.7 8.1 15.6 16.9 16.9 8.7 1.2 17.3-3.4 20.9-11.4-3.5 4.5-9 7.1-14.7 7.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m66.4 78.5c-0.6 0-1.1-0.2-1.5-0.6l-5.6-5.6c-0.8-0.8-0.8-2.2 0-3.1 0.9-0.9 2.3-0.9 3.2 0l3.9 4 9.5-9.5c0.9-0.9 2.3-0.9 3.2 0 0.8 0.8 0.8 2.2 0 3.1l-11.1 11.1c-0.4 0.4-1 0.6-1.6 0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.99
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m106.7 49.3c0 5.5-9.9 20.5-9.9 20.5 0 0-9.9-15-9.9-20.5 0-5.4 4.4-9.9 9.9-9.9 5.5 0 9.9 4.5 9.9 9.9z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m102.9 49.4c0 3.4-2.7 6.2-6.1 6.2-3.4 0-6.1-2.8-6.1-6.2 0-3.3 2.7-6.1 6.1-6.1 3.4 0 6.1 2.8 6.1 6.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.116b4ef868a84bd873ec07bd7441b99f.svg";
export { ForwardRef as ReactComponent };